import { useEffect, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import NumberToPersianWord from "number_to_persian_word";

const PriceInput = (props) => {

    const [word, setWord] = useState("")
    const [inputValue, setInputValue] = useState()
    const [inputSuffix, setInputSuffix] = useState("")

    function priceInputHandler(value) {
        if (value) {
            if (props.data.currency === "rial") {
                setInputSuffix(" ریال")
                let convertValue = Math.trunc((value / 10))
                setWord(`${NumberToPersianWord.convert(convertValue)} تومان`);
            }
            else {
                setInputSuffix(" تومان")
                setWord(`${NumberToPersianWord.convert(value)}`);
            }
            setInputValue(value)
        } else {
            setInputValue("")
            setWord("")
        }
    }

    function priceInputOnblur() {
        if (props.HasManyInputData) {
            props.HasManyInputData(props.index, props.HasManyKey, inputValue);
        } else {
            let object = props.inputData;
            object[props.data.key] = inputValue;
            props.setInputData(object);
        }
    }

    useEffect(()=>{
        priceInputHandler(props.editDataValue)
    },[])

    return (
        <>
            <div className="col-span-full sm:col-auto">
                <CurrencyInput
                    id="priceInput"
                    placeholder=""
                    defaultValue={props.editDataValue}
                    allowDecimals={false}
                    allowNegativeValue={false}
                    onValueChange={(value) => { priceInputHandler(value) }}
                    suffix={inputSuffix}
                    maxLength={props.data.max}
                    className={`h-[38px] border border-edit_input_border rounded-[4px] px-3 w-full ${(props.item.disabled !== undefined ||props.item.disabled) ?"bg-[#e9e9e9] cursor-not-allowed dark:bg-[#b5b5b5] text-edit_input_text_disabled":"bg-white dark:bg-[#ffffffdd] text-edit_input_text"}`}
                    onBlur={priceInputOnblur}
                    disabled={props.item.disabled}
                />
                <div className="mt-2 text-[.8rem] text-edit_input_text">
                    {word} تومان
                </div>
                <div className="mt-2 text-[.8rem] text-edit_input_validation">
                    {props.children}
                </div>
            </div>
        </>
    );
}

export default PriceInput;